export default __webpack_public_path__ + "static/media/ic_empty_j4u.bd9f40a4.svg";